// import * as moment from 'moment';
import axios from 'axios';
import moment from 'moment';
const dir = window.location.href
export const isNotProductive = (dir.includes('/desa') || dir.includes('/pmdemo') || process.env.NODE_ENV === "development")

export const totalShow = 15;
export const adminLevel = 5;

export const sexOptions = [
    { value: 'M', label: 'Masculino' },
    { value: 'F', label: 'Femenino' },
];

export const yesNoOptions = [
    { value: true, label: 'Si' },
    { value: false, label: 'No' },
];

export const useOptions = [
    { value: 'P', label: 'Particular' },
    { value: 'C', label: 'Comercial' },
];

export const houseOptions = [
    { value: 0, label: 'Casas y Deptos en Planta Baja' },
    { value: 1, label: 'Deptos 1 Piso en adelante / Casas en Countries / Barrios Cerrados' },
];

export const sinHeader = [
    "Pto y Nro de Credito",
    "Legajo",
    "Usuario",
    "DNI",
    "Apellido y Nombre",
    "Compañía",
    "Rama",
    "Fecha denuncia",
    "Fecha siniestro",
    "Fecha pagado",
    "Importe pagado",
    "Nro Certificado",
    "Estado",
    "Cobertura",
    "Causa",
    "Capital asegurado",
    "Descripción del evento",
];

export const sinHeaderRisk = [
    "DNI",
    "Nombre y Apellido",
    "Punto y Nro Crédito",
    "Saldo",
]

export const sinBeneficiary = [
    "Nombre",
    "Apellido",
    "Dirección",
    "Fecha Nacimiento",
    "Lugar Nacimiento",
    "Telefono",
    "Email",
    "DNI",
    "Relación",
    "Porcentaje",
    "DDJJ Impuesto",
    "Forma de Pago",
    "Nro de Cuenta",
    "Banco",
    "CBU",
    "Titular",
];

export function handleDate(date) {
    // función para devolver la fecha como lo necesita el back //
    if (typeof date === "string") {
        date = date.split("/").reverse().join();
    }
    return new Date(date)
        .toLocaleDateString("zh-Hans-CN", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
        })
        .replaceAll("/", "-");
};

export function handleDateMDA(date) {
    // función para devolver la fecha como lo necesita el back MM/DD/AAAA//
    if (!date) return
    if (date.split("-")[0].length === 4) return date
    date = date.split("/");
    return `${date[2]}-${date[1]}-${date[0]}`;
};

export function showDate(date) {
    if (!date) return null;
    if (typeof date !== 'string') return date;
    date = date.split("-");
    return `${date[2]?.length > 1 ? date[2] : `0${date[2]}`}/${date[1]?.length > 1 ? date[1] : `0${date[1]}`}/${date[0]}`;
};

export function policyDate(str) {
    if (!str) return str;
    if (typeof str !== 'string') return str;
    str = str.replaceAll("-", "/");
    str = str.split("/");
    const day = str[2];
    const month = str[1] - 1;
    const year = str[0];
    return new Date(year, month, day);
};

export function strToDate(str) {
    if (!str) return;
    if (typeof str !== 'string') return str;
    str = str.replaceAll("-", "/");
    str = str.split("/");
    const day = str[0];
    const month = str[1] - 1;
    const year = str[2];
    return new Date(year, month, day)
        .toLocaleDateString('es-ES', { month: "2-digit", day: "2-digit", year: "numeric" });
};

export function getAge(date) {
    let hoy = new Date();
    let fnacimiento = strToDate(date);
    let newF = fnacimiento.split("/").reverse().join();
    newF = new Date(newF);
    let edad = hoy.getFullYear() - newF.getFullYear();
    let m = hoy.getMonth() - newF.getMonth();

    if (m < 0 || (m === 0 && hoy.getDate() < newF.getDate())) {
        edad--;
    }
    return edad;
};

// export const validateEmail = (mail) => (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail));
// export const validateEmail = (mail) => (/^[a-z0-9!#$%&'*+/=?^_`{|}~-]{3,}(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail));
//export const validateEmail = (mail) => (/^[a-z0-9!#$%&'*+/=?^_`{|}~-]{1,}(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail));
export const validateEmail = (mail) => (
    /^[a-zA-Z0-9!#$%&'*+/=?^_`{}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{}~-]+)*@[a-zA-Z0-9]+([.-]?[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,6})+$/.test(mail) &&
    mail.split('@')[0].replace(/\./g, '').length >= 3
  );

export function validateCreditCard(num) {
    num = num.replaceAll(" ", "");
    const regex = new RegExp("^[0-9]{13,19}$");
    if (!regex.test(num)) return false;

    const luhnck = (val) => {
        let validsum = 0;
        let k = 1;
        for (let l = val.length - 1; l >= 0; l--) {
            let calck = 0;
            calck = Number(val.charAt(l)) * k;
            if (calck > 9) {
                validsum = validsum + 1;
                calck = calck - 10;
            }
            validsum = validsum + calck;
            if (k === 1) k = 2;
            else k = 1;
        };
        return (validsum % 10) === 0;
    };
    return luhnck(num);
};

export const BINs = {
    "AMEX":["37"],
    "ARGC":["52","53","54","55"],
    "BBVA":["4"],
    "CAB":["45","47","52","58","60","62","65"], 
    "CCARD":["5545","51","62"],
    //"CFR":[], 
    //"CLIPER":[],
    //"//CRE":[], 
    //"CRM":[], 
    "CSD":["60","90","51","52","55"], 
    //"DAT":[], 
    "DINERS":["36","54","58"],
    //"ELE":[], 
    //"MAS":[], 
    "MASTER":["5","23","24"],
    "MASTERC":["5","23","24"],
    "NAM":["5","47"], 
    "NNa":["5"], 
    "NX": ["589562","40","43","45","49","52","53","54", "55", "58"],  
    "NXV":["589562","40","43","45","49","52","53","54", "55", "58"], 
    //"TCN":[], 
    "VISA":["4"],
    "VISAD":["4"]
}


export function validateCBU(cbu) {
    // const block1 = cbu.substring(0, 7).split("");
    // const block2 = cbu.substring(8, 21).split("");
    // const digit1 = Number(cbu[7]);
    // const digit2 = Number(cbu[21]);
    // const arr1 = [7, 1, 3, 9, 7, 1, 3];
    // const arr2 = [3, 9, 7, 1, 3, 9, 7, 1, 3, 9, 7, 1, 3];
    // let valid = false;

    // let acum = 0;
    // block1.forEach((block, ix) => (acum += block * arr1[ix]));

    // let strAcum = acum.toString();
    // let digitoVCalculado1 = 10 - strAcum.substring(strAcum.length - 1);
    // valid = digitoVCalculado1 === digit1;

    // acum = 0;
    // block2.forEach((block, ix) => (acum += block * arr2[ix]));

    // strAcum = acum.toString();
    // let digitoVCalculado2 = 10 - strAcum.substring(strAcum.length - 1);
    // return digitoVCalculado2 === digit2 && valid;
    return cbu.toString().length === 22 || cbu.toString().length === 11; //por los numeros de cuenta chilenos
};

export function validateDni(dni) {
    let validate_dni = /^\d{8}(?:[-\s]\d{4})?$/;
    let validate_dni2 = /^\d{7}(?:[-\s]\d{4})?$/;

    if (dni.length === 8) {
        if (validate_dni.test(dni)) return false;
    }
    if (dni.length === 7) {
        if (validate_dni2.test(dni)) return false;
    }
    return true;
};

export function validateDate(date, year = "1800") {
    if (date?.substring(date.length, date.length - 4) > year) {
        let result = moment(date, 'DD/MM/YYYY', true).isValid();
        return result;
    } else return false;
};

export const compareDateWithToday = (value) => {
    let date = new Date(value.split("/").reverse().join("/"));
    let hoy = new Date();
    return hoy >= date ? true : false;
};

export function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
}

export const eliminarDiacriticosEsNum = (text) => {
    return text?.normalize('NFD')
        .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1")
        .normalize();
};

export const eliminarDiacriticosEs = (text) => {
    return text?.replace(/[0-9]/g, "")
        .normalize('NFD')
        .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1")
        .normalize();
};

export const verifyDateExpires = (date) => {
    const mes = Number(date.split("/")[0]);
    const anio = Number("20" + date.split("/")[1]);
    if (mes > 12) return false;
    if (anio < new Date().getFullYear()) return false;
    return new Date(anio, mes - 1, 1) >= new Date();
};

export const verifyInvoice = (num) => {
    let regex = new RegExp("^[0-9/./-]{1,30}$");
    return (regex.test(num));
};


export const verifyData = (data, step, recid) => {
    if (data.payMethod === "2") return { error: false };
    if (data.payMethod === "3") return { error: false };
    if ((!recid && step !== "Menu" || !recid && !step)) {
        return {
            borrado: true,
            status: "Revisar el código, se borró el recid o el step.",
        };
    }
    if (step === "Menu" || step === "TitularData") {
        if (Object.keys(data).length < 10) {
            return {
                borrado: true,
                status: "Revisar el código, se borró información importante.", //Este fragmento valida que no haya borrado de props
                client: "Hubo un error al cargar la información. Aguarde unos minutos y vuelva a intentarlo. Gracias"
            }
        };
    };
    if (step === "HomeData") {
        if (Object.keys(data).length < 4) {
            return {
                borrado: true,
                status: "Revisar el código, se borró información importante.",
                client: "Hubo un error al cargar la información. Aguarde unos minutos y vuelva a intentarlo. Gracias",
            }
        };
    };
    if (step === "VehicleData") {
        if (data.company === 4 || data.company === 54) return { error: false }
        if (Object.keys(data).length < 3) {
            return {
                borrado: true,
                status: "Revisar el código, se borró información importante.",
                client: "Hubo un error al cargar la información. Aguarde unos minutos y vuelva a intentarlo. Gracias",
            }
        };
    };
    if (step === "PayMethod") {
        if (Object.keys(data).length < 6) {
            return {
                borrado: true,
                status: "Revisar el código, se borró información importante.",
                client: "Hubo un error al cargar la información. Aguarde unos minutos y vuelva a intentarlo. Gracias",
            }
        };
    };
    let isEmpty = 0;
    let properties = [];
    for (const prop in data) {
        if (data[prop] === '' && data.codsec !== 27) {
            properties = [...properties, prop]
            isEmpty += 1;
        };
    };
    if (isEmpty === 0)
        return {
            error: false,
            properties,
            totalNumberProperties: isEmpty,
            status: "Todo bien, llegó la información Ok."
        };
    else
        return {
            error: true,
            properties,
            totalNumberProperties: isEmpty,
            status: "Hubo un error al cargar la información. Aguarde unos minutos y vuelva a intentarlo. Gracias"
        };
};

export const validatePatent = (patent) => {
    let regex = /^([A-Za-z]{1}\d{3}[A-Za-z]{3})$/i;
    return patent.length === 7 && regex.test(patent);
};

export const handleKeyPress = (event) => {
    const currentValue = event.target.value;
    const keyCode = event.keyCode || event.which;
    if (keyCode === 69 || keyCode === 101) event.preventDefault();
    if (currentValue.includes('e') || currentValue.includes('E')) event.preventDefault();
};

export const getCUIT = (dni, gender = 'M') => {
    if (dni.length < 7 || dni.length > 8) {
        //console.log('error')
    };
    let genderNumber = gender === 'M' ? 20 : 27;

    const generateDigitVerificator = () => {
        const multipliers = [2, 3, 4, 5, 6, 7];
        const genderNumberAndDNI = `${genderNumber}${dni}`;

        let total = 0;
        let multipliersIndex = 0;
        for (let i = String(genderNumberAndDNI).length - 1; i > -1; i--) {
            const sum = genderNumberAndDNI[i] * multipliers[multipliersIndex];
            total += sum;
            if (multipliersIndex === 5) multipliersIndex = 0;
            else multipliersIndex += 1;
        }
        const digitVerificator = 11 - (total % 11);
        if (digitVerificator === 10) {
            genderNumber = 23;
            return generateDigitVerificator();
        }
        if (digitVerificator === 11) return 0;
        return digitVerificator;
    };

    const digitVerificator = generateDigitVerificator();

    return `${genderNumber}${dni}${digitVerificator}`;
};


export const putLogs = async (url, params, options, r) => {
    const paramss = new URLSearchParams();
    const paramsObj = Object.fromEntries(params.entries());
    paramss.set('params', JSON.stringify(paramsObj));
    paramss.set('url', JSON.stringify(url));
    paramss.set('options', JSON.stringify(options));
    paramss.set('r', JSON.stringify(r));
   
    const urlLog = `${process.env.REACT_APP_NODE_APP}/putLogs`;
    // const dta = JSON.stringify({ url, params, options, r })
    const data = await axios.post(urlLog, paramss, { headers: { "Content-Type": "application/x-www-form-urlencoded" } })


};